import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../shared/data/queryKeys';
import { getMeetingDetail } from './api';

export function useMeetingDetail(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.meeting(id ?? ''),
    queryFn: () => getMeetingDetail(id as string),
    enabled: id !== undefined && id.length > 0,
  });
}
